import React from 'react';
import { useWebContents } from '../../hooks/useWebContents';

const GUIDS = {
  whatWeDo: '31e7c8be-404c-448b-9132-026b5f6e3cee',
};

const WhatWeDoBanner: React.FC = () => {
  const contents = useWebContents(GUIDS, 'Home');
  return (
    <section className="w-full py-12 flex flex-col items-center ">
      <div className="bg-[#1a3a1a] w-full py-12 flex flex-col items-center px-4 sm:px-6 ">
        <h2 className="text-3xl md:text-4xl font-bold text-white mb-4 uppercase tracking-wide ">
          {contents.whatWeDo.heading}
        </h2>
        <div className="w-80 h-1 bg-[#AE582D] rounded mb-8" />
        <div className="max-w-3xl text-center mb-10">
          <p className="text-lg md:text-xl text-white font-medium text-[18px] ">
            {contents.whatWeDo.content}
          </p>
        </div>
      </div>
    </section>
  )
};

export default WhatWeDoBanner;